<template>
    <!-- 行业服务 -->
    <section class="indBlock titLeft bgw">
        <div class="containers">
            <div class="container">
            <div class="hd clearfix">
                <h3><a href="#">行业服务</a></h3>
                <div class="introTxt">高质量行业服务案例</div>
                <div class="more"><a class="btn hoverBg" href="#" v-if="false">更多服务</a></div>
            </div>
            </div>
            <div class="bd">
                <div class="industryDiv mt30">
                    <div class="industryWrap">
                        <div class="industryUl clearfix">
                            <div class="item" @click="showDetail(1)">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/industry-zf.png">
                                </div>
                                <div class="txt">
                                    <h3>政府部门</h3>
                                    <ul class="sub">
                                        <li @click="showDetail(1)">纳税评估</li>
                                        <li @click="showDetail(1)">律师信用评估</li>
                                        <li @click="showDetail(1)">个人信用评估</li>
                                        <li @click="showDetail(1)">企业信用评估</li>
                                        <li @click="showDetail(1)">公安经济犯罪侦查</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="item" @click="showDetail(2)">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/industry-sc.png">
                                </div>
                                <div class="txt">
                                    <h3>生产制造</h3>
                                    <ul class="sub">
                                        <li @click="showDetail(2)">智能自动配方仿真</li>
                                        <li @click="showDetail(2)">厌氧消化过程预测和预警</li>
                                        <li @click="showDetail(2)">桩基完整性检测</li>
                                        <li @click="showDetail(2)">石油勘探中油气层自动评价</li>
                                        <li @click="showDetail(2)">家电用户使用习惯数据挖掘</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="item" @click="showDetail(3)">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/industry-jr.png">
                                </div>
                                <div class="txt">
                                    <h3>金融保险</h3>
                                    <ul class="sub">
                                        <li @click="showDetail(3)">客户细分分析</li>
                                        <li @click="showDetail(3)">客户细分分析</li>
                                        <li @click="showDetail(3)">银行信用等级评估</li>
                                        <li @click="showDetail(3)">企业信用评估</li>
                                        <li @click="showDetail(3)">公安经济犯罪侦查</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="item" @click="showDetail(4)">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/industry-nc.png">
                                </div>
                                <div class="txt">
                                    <h3>农畜牧业</h3>
                                    <ul class="sub">
                                        <li @click="showDetail(4)">水产健康养殖专家系统</li>
                                        <li @click="showDetail(4)">水产主导品种数据化专家系统</li>
                                        <li @click="showDetail(4)">水色图像预测评价</li>
                                        <li @click="showDetail(4)">水产养殖投入产出多目标优化仿真</li>
                                        <li @click="showDetail(4)">海水增养殖区环境综合评价</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="item" @click="showDetail(5)">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/industry-dx.png">
                                </div>
                                <div class="txt">
                                    <h3>电信行业</h3>
                                    <ul class="sub">
                                        <li @click="showDetail(5)">离网客户预测分析</li>
                                        <li @click="showDetail(5)">客户价值分析</li>
                                        <li @click="showDetail(5)">客户信用度分析</li>
                                        <li @click="showDetail(5)">电信资源预测模型</li>
                                        <li @click="showDetail(5)">精准智能营销分析</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="item" @click="showDetail(6)">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/industry-yl.png">
                                </div>
                                <div class="txt">
                                    <h3>医疗卫生</h3>
                                    <ul class="sub">
                                        <li @click="showDetail(6)">乳腺癌证素变化规律及截断疗法模型</li>
                                        <li @click="showDetail(6)">基于内容图像检索的脑瘤早期辅助诊断模型</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="item" @click="showDetail(7)">
                                <div class="img">
                                    <img src="@/pages/frontend/assets/images/industry-ls.png">
                                </div>
                                <div class="txt">
                                    <h3>零售商贸</h3>
                                    <ul class="sub">
                                        <li @click="showDetail(7)">精准智能营销</li>
                                        <li @click="showDetail(7)">展会贸易匹配</li>
                                        <li @click="showDetail(7)">客户需求倾向分析</li>
                                    </ul>
                                </div>
                            </div>
                      </div>
                    </div>
                    <div class="leftBtn"><i class="el-icon-arrow-left"></i></div>
                    <div class="rightBtn"><i class="el-icon-arrow-right"></i></div>
                </div>
                <!-- <div id="hyfu" class="tabDiv mt30">
                    <div class="hds">
                        <ul>
                            <li class="on"><a>电信行业</a></li>
                            <li><a>医疗卫生</a></li>
                            <li><a>金融保险</a></li>
                            <li><a>生产制造</a></li>
                            <li><a>零售商务</a></li>
                            <li><a>农畜牧业</a></li>
                            <li><a>政府部门</a></li>
                        </ul>
                    </div>
                    <div class="bds">
                        <div class="tabContent">
                            <div class="subImg"><img src="@/pages/frontend/assets/images/dxhy.jpg"></div>
                            <div id="lwkhycfx" class="inTabDiv">
                                <div class="tabHd">
                                    <ul>
                                        <li class="active"><a>离网客户预测分析</a></li>
                                        <li><a>客户价值分析</a></li>
                                        <li><a>客户信用度分析</a></li>
                                        <li><a>电信资源预测模型</a></li>
                                        <li><a>精准智能营销分析</a></li>
                                        <li><a>电信市场客户细分</a></li>
                                    </ul>
                                </div>
                                <div class="tabBd">
                                    <div class="content">
                                        <div class="txt">
                                            <p>客户流失是电信行业普遍面临的业务问题，尤其是在市场成熟期的时候，竞争异常激烈，市场的渗透比率很高 以至于通信公司必须从他的竞争对手处“盗窃”客户，另一方面，通信公司的客户也被他的竞争对手“盗窃” 当被“盗窃”的客户的数字很高的时候就成为严重的流失问题 离网客户预测分析就是针对以上问题，建立离网客户预测模型并且产生最可能离网的客户名单 结合每个客户的价值评分，协助通信公司采取合适的客户挽留措施。</p>
                                            <p>以保持通信公司收入和确保客户忠诚度客户流失是电信行业普遍面临的业务问题，尤其是在市场成熟期的时候，竞争异常激烈，市场的渗透比率很高 以至于通信公司必须从他的竞争对手处“盗窃”客户，另一方面，通信公司的客户也被他的竞争对手“盗窃” 当被“盗窃”的客户的数字很高的时候就成为严重的流失问题 离网客户预测分析就是针对以上问题，建立离网客户预测模型并且产生最可能离网的客户名单 结合每个客户的价值评分，协助通信公司采取合适的客户挽留措施，以保持通信公司收入和确保客户忠诚度</p>
                                        </div>
                                    </div>
                                    <div class="content">客户价值分析，内容上传中…</div>
                                    <div class="content">客户信用度分析，内容上传中…</div>
                                    <div class="content">电信资源预测模型，内容上传中…</div>
                                    <div class="content">精准智能营销分析，内容上传中…</div>
                                    <div class="content">电信市场客户细分，内容上传中…</div>
                                </div>
                            </div>
                        </div>
                        <div class="tabContent">医疗卫生，内容上传中…</div>
                        <div class="tabContent">金融保险，内容上传中…</div>
                        <div class="tabContent">生产制造，内容上传中…</div>
                        <div class="tabContent">零售商务，内容上传中…</div>
                        <div class="tabContent">农畜牧业，内容上传中…</div>
                        <div class="tabContent">政府部门，内容上传中…</div>
                    </div>
                </div> -->
            </div>
            <!-- <div class="fd">
                <a class="btn bigBtn blueSty hoverShadow" href="#">申请项目服务</a>
            </div> -->
        </div>
    </section>
</template>
<script>
import { cardSroll } from '@/pages/frontend/assets/js/all.js';
    export default {
        created() {
        },
        mounted:function(){
            this.industryRoll();
        },
        methods: {
            industryRoll(){
                let indexNav = new cardSroll('.industryDiv', {visNum:3, rollNum:3, fixWidth:30})
            },
            showDetail(num){
                let uri = '';
                switch(num){
                    case 1:
                        uri = 'http://www.tipdm.com/gdjjfa/985.jhtml';
                        break
                    case 2:
                        uri = 'http://www.tipdm.com/gdjjfa/988.jhtml';
                        break
                    case 3:
                        uri = 'http://www.tipdm.com/gdjjfa/990.jhtml';
                        break
                    case 4:
                        uri = 'http://www.tipdm.com/gdjjfa/986.jhtml';
                        break
                    case 5:
                        uri = 'http://www.tipdm.com/gdjjfa/992.jhtml';
                        break
                    case 6:
                        uri = 'http://www.tipdm.com/gdjjfa/991.jhtml';
                        break
                    default:
                        uri = 'http://www.tipdm.com/gdjjfa/987.jhtml';
                        break
                }
                window.open(uri)
            },
        }
    }
</script>